import React from "react";
import clsx from 'clsx';
import {
    ServiceDialog,
    CancelButton,
    ConfirmButton,
    NameTextField
} from '../../../styling/Styles';
import {
    checkPageNameExists,
    checkHasSpaces,
    checkIfEmpty
} from '../../../validations/validations';

const PopUpValidationCore = (props) => {

    const{
        title,
        page_description,
        open,
        setOpen,
        handlePageName,
        pageName,
        selectedProject,
        handleCancel,
        updateAttributes,
        selectedPage,
        cause
    }=props

    const closeDialog = () => {
        setOpen(false);
    }

    const returnHelperText = () => {
        if(checkIfEmpty(pageName) === true){
            return 'Page name empty';
        }
        if(checkHasSpaces(pageName) === true){
            return 'Spaces are not allowed';
        }
        if(checkPageNameExists(pageName, selectedProject,selectedPage) === true){
            return 'Page name already exists';
        }
        return null;
    }

    return(
        <ServiceDialog
            open={open}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        > 
                <div className={clsx('titlePopUp','paddingTitle')}> 
                {title}
                <div onClick={closeDialog} className={clsx('pop-up-close-btn')} aria-hidden="true">x</div>
                </div>
                <div className ='paddingTitle'>
                
                
                    <div className={clsx('flexRowDirection')} style ={{marginTop: '1vw'}}> 
                        <div className={clsx('lightBlue')}>  {page_description} : &nbsp; </div>   
                        <NameTextField
                            id={`pageNameInput${cause}`}
                            placeholder=' page name'
                            onInput={e =>handlePageName(e)}
                            onChange={() =>{}}
                            value={pageName || ''}
                            error={checkIfEmpty(pageName) === true || checkHasSpaces(pageName) === true || checkPageNameExists(pageName, selectedProject,selectedPage)}
                            helperText={ returnHelperText()}
                        />
                    </div> 

                
                    <div className={clsx('flex-container', 'spacingDownDiv')} 
                        style={{
                            justifyContent:'space-between',
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: '1vw'
                        }}

                    >
                        <div >
                            <CancelButton 
                                onClick={handleCancel}
                            >
                                Cancel
                            </CancelButton >
                        </div>
                        <div className={clsx('flexRowDirection')}>
                            <ConfirmButton 
                                onClick={updateAttributes}
                                id={`confirmButton${cause}`}
                            >
                                {cause === 'RenamePage' ? 'Rename'  : 'Create' }
                            </ConfirmButton>
                            <div> &nbsp;</div>
                        </div>
                    </div>
            </div>

        </ServiceDialog>
    )

}

export default PopUpValidationCore;